import {
  ContentLayout,
  HeaderBreadcrumbs,
  NewFormCardWrapper,
  PageNotFound,
} from "../../../shared";
import * as React from "react";
import { Button } from "@mui/material";
import { useParams } from "react-router-dom";

import { useOptionalGroup } from "../hooks/useOptionalGroup";
import SimpleReactValidator from "simple-react-validator";
import { MultiLanguageNameTable } from "../../Category";
import InputControl from "../../../shared/components/InputControl";

export const AddOrEditOptionalGroup = () => {
  const { id } = useParams();
  const { state, onSaveOptionalGroup, onChange, onUpdateOptionalGroup } =
    useOptionalGroup({
      isOptionalGroup: false,
      optionalId: id,
      isProduct: false,
    });
  const [, forceUpdate] = React.useState();
  const validator = React.useRef(
    new SimpleReactValidator({ autoForceUpdate: { forceUpdate: forceUpdate } })
  );

  const onSubmit = () => {
    if (validator.current.allValid()) {
      id ? onUpdateOptionalGroup(id) : onSaveOptionalGroup();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  if (state.httpStatusCodes.details === 404) {
    return <PageNotFound />;
  }

  const columns = [
    {
      head: "Language",
      accessor: "lang",
      sx: { width: "20%", minWidth: "150px" },
    },
    {
      head: "Group Name*",
      accessor: (row, index) => {
        const modifierNameMessage = validator.current.message(
          `${row.code} Group Name`,
          row.locale_name,
          "required",
        );
        return (
          <InputControl
            name="locale_name"
            label=""
            value={row.locale_name}
            onChange={(e) => onChange(e, index)}
            required
            error={!!modifierNameMessage}
            helperText={modifierNameMessage}
          />
        );
      },
      sx: { width: "80%" },
    },
  ];

  return (
    <ContentLayout
      title={id ? state.optionalGroupName : "New Group"}
      breadcrumbs={
        <HeaderBreadcrumbs
          links={[
            { name: "Dashboard", href: "/" },
            { name: "Modifier Groups", href: "/optionalGroup" },
            id
              ? {
                  name: state.optionalGroupName,
                  href: `/optionalGroup/details/${id}`,
                }
              : null,
            { name: id ? "Edit" : "Create" },
          ].filter(Boolean)}
        />
      }
      rightContent={
        <Button
          onClick={() => onSubmit()}
          type="button"
          size="medium"
          variant="contained"
          disabled={state.isSaveButtonBusy}
        >
          {id ? "Update" : "Save"}
        </Button>
      }
    >
      <NewFormCardWrapper title="Details">
        <MultiLanguageNameTable
          columns={columns}
          data={state.modifierNamings}
          loading={state.modifierNamingsLoading}
        />
      </NewFormCardWrapper>
    </ContentLayout>
  );
};
